import Utils from "./Utils";

export default class ModalSelect {
  constructor(parent_context) {
    this.parent_context = parent_context;

    this.select_modal == null;
    this.cities = null;

    this.search_count_limit = 10; // Лимит отображения найденных городов

    this.elements_ids = {
      modal_select: "city-changer__modal-select",
      btn_close: "city-changer__btn-close",
      search_input: "city-changer__search-input",
      search_values: "city-changer__search-values",
    };

    this.main_btn = document.querySelector(
      "#" + this.parent_context.elements_ids.main_btn
    );

    this.Utils = new Utils();
  }

  renders = {
    selectModal: async () => {
      await fetch("assets/template/json/cities.json")
        .then((response) => response.json())
        .then((data) => {
          this.cities = data;
        })
        .catch((err) => {
          console.error("Ошибка при получении списка городов: " + err);
        });

      const modal = document.createElement("div");
      modal.className = "city-changer__modal-select";
      modal.id = this.elements_ids.modal_select;

      if (this.cities == null) {
        modal.innerHTML = `
        <div class="city-changer__title">К сожалению не удалось получить список городов</div>
        <button class="city-changer__close" id="${this.elements_ids.btn_close}">&#x2715;</button>
    `;
      } else {
    //     modal.innerHTML = `
    //     <div class="city-changer__title">Выберите город</div>
    //     <div class="city-changer__links">
    //       <ul class="city-changer__links-main">
    //           ${this.renders.mainLinks()}
    //       </ul>
    //       <input placeholder="Поиск города" class="city-changer__search-input" id="${
    //         this.elements_ids.search_input
    //       }">
    //       <ul class="city-changer__links-other" id="${
    //         this.elements_ids.search_values
    //       }">
    //       </ul>
    //     </div>
    //     <button class="city-changer__close" id="${
    //       this.elements_ids.btn_close
    //     }">&#x2715;</button>
    // `;
     // Пока сказали убрать поиск...
     modal.innerHTML = `
        <div class="city-changer__title">Выберите город</div>
        <div class="city-changer__links">
          <ul class="city-changer__links-main">
              ${this.renders.mainLinks()}
          </ul>
        </div>
        <button class="city-changer__close" id="${
          this.elements_ids.btn_close
        }">&#x2715;</button>
    `;
      }

      this.select_modal = modal;

      this.Utils.whereToAdd(
        "#" + this.parent_context.elements_ids.parent_block,
        modal
      );

      // Назначаем события
      this.events.searchInput(
        "#" + this.elements_ids.search_input,
        "#" + this.elements_ids.search_values
      );
      this.events.close("#" + this.elements_ids.btn_close);
      this.events.closeToEmptyArea();
    },
    mainLinks: () => {
      let result = "";

      this.cities.main.forEach((city) => {
        result += `<li><a onclick="document.cookie = 'city_name=${city.name}';location.href = location.href + (location.href.includes('?') ? '&' : '?')+'${this.parent_context.get_param_name}=${city.key}'">${city.name}</a></li>`;
      });

      return result;
    },
  };

  events = {
    /**
     * @param {*} selector_input - Поле поиска
     * @param {*} selector_values - Блок для сохранения значений
     */
    searchInput: (selector_input, selector_values) => {
      const input_elem = this.Utils.checkElement(selector_input);
      if (typeof input_elem !== "object") return;

      const values_elem = this.Utils.checkElement(selector_values);
      if (typeof values_elem !== "object") return;

      input_elem.addEventListener("input", (event) => {
        let search_count = 0;

        values_elem.innerHTML = "";

        const input_value = event.target.value.toLowerCase().trim();

        if (input_value.length == 0) return;

        this.cities.other.forEach((city) => {
          if (
            city.name.toLowerCase().includes(input_value) &&
            search_count < this.search_count_limit
          ) {
            search_count++;

            // const a = document.createElement("a");
            // a.textContent = city.name;

            // a.onclick = () => {
            //   this.select_modal.classList.remove("opened");
            //   this.main_btn.textContent = city.name;
            //   this.main_btn.className = ""; // Сбрасываем класс, так как по нему у нас псевдотекст
            //   document.cookie = "city_name=" + city.name;
            //   document.cookie = "city_change=" + city.name;
            // };

            const a = `<a onclick="document.cookie = 'city_name=${city.name}';location.href = location.href + (location.href.includes('?') ? '&' : '?')+'${this.parent_context.get_param_name}=${city.key}'">${city.name}</a>`;

            const li = document.createElement("li");
            li.innerHTML = a;

            values_elem.appendChild(li);
          }
        });
      });
    },
    /**
     * Откроется модалка для выбора города
     * @param {*} selector - Селектор кнопки
     */
    open: (selector) => {
      const open_elem = this.Utils.checkElement(selector);

      if (typeof open_elem !== "object") return;

      open_elem.addEventListener("click", async () => {
        // Если модалки нет - создаем ее
        if (this.select_modal == null) {
          await this.renders.selectModal();
        }

        this.select_modal.classList.add("opened");
      });
    },
    /**
     * @param {*} selector - Селектор кнопки
     * @param {*} elem - Если передана кнопка то пропускаем селектор
     */
    close: (selector, elem = null) => {
      let close_elem;

      if (elem) {
        close_elem = elem;
      } else {
        close_elem = this.Utils.checkElement(selector);
        if (typeof close_elem !== "object" || !this.select_modal) return;
      }

      close_elem.addEventListener("click", () => {
        this.select_modal.classList.remove("opened");
      });
    },
    /**
     * Закрытие модалки при клике на пустую область
     * Вызываем функию при рендере
     */
    closeToEmptyArea: () => {
      document.addEventListener("click", (event) => {
        // Элементы клик по которым не должен закрывать окно
        if (
          !this.select_modal.contains(event.target) &&
          !this.main_btn?.contains(event.target)
        ) {
          this.select_modal.classList.remove("opened");
        }
      });
    },
  };
}